module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_photowedding@3x-98658d4bc3db612880150718c840afd1.webp";